import { useState, useEffect, useCallback } from 'react';

const useHelpDeskMultiSelectFilter = (initialMap, { onApply, hideLayout, handleClose }) => {
  const [selectedMap, setSelectedMap] = useState(initialMap);

  useEffect(() => {
    setSelectedMap(initialMap);
  }, [initialMap]);

  const applySelection = useCallback(
    (nextMap) => {
      const values = Object.values(nextMap);
      onApply(values.length ? values : null);
      if (!hideLayout) handleClose?.();
    },
    [onApply, hideLayout, handleClose]
  );

  const handleToggle = useCallback(
    (key, entry) => {
      const nextMap = { ...selectedMap };
      if (nextMap[key]) {
        delete nextMap[key];
      } else {
        nextMap[key] = entry;
      }
      setSelectedMap(nextMap);
      if (hideLayout) applySelection(nextMap);
    },
    [selectedMap, hideLayout, applySelection]
  );

  const clearSelection = useCallback(() => {
    setSelectedMap({});
    applySelection({});
  }, [applySelection]);

  return { selectedMap, applySelection, handleToggle, clearSelection };
};

export default useHelpDeskMultiSelectFilter;
